export enum TemplateType {
    first = 'first',
    second = 'second',
}